//
//
//
//
//
//
//
//
//
//
//

//
export default {
  name: "iconfontLoading",
  props:[
    'size',
    'color',
  ]
};



// WEBPACK FOOTER //
// ./src/items/iconfontLoading.vue